<div
  class="flex flex-col h-min-[294px] w-[345px] rounded-md pb-[37px] pl-[29px] pr-[21px] pt-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] sm:h-[384px] sm:w-[571px] sm:rounded-xl
  sm:pb-[73px] sm:pl-[55px] sm:pr-[28px] sm:pt-[28px] bg-white items-center">
  <div class="flex w-full justify-end">
    <button class="cursor-pointer" (click)="closeButton()">
      <ln-close-svg-icon [class]="'h-[36px] w-[36px] cursor-pointer hover:scale-110'" [fillColor]="'#372121'"></ln-close-svg-icon>
    </button>
  </div>
    <div
      class="w-[245px] sm:w-[450px] mt-[19px] justify-center text-center text-lg font-semibold sm:leading-loose text-cafe sm:mt-[78px] sm:text-2xl">
      {{tittle}}
    </div>
    <div
      class="mt-[20px] flex justify-start text-center text-base font-medium leading-tight text-verde sm:text-lg sm:leading-normal">
      {{textBody}}
    </div>
  <div class="flex w-full justify-center sm:mt-[18px]">
    <ln-primary-button
      [class]="
        'mt-[30px] flex h-[50px] w-[205px] justify-center items-center rounded-md bg-[#577778] text-white text-base font-semibold transition hover:bg-[#305447] sm:mt-[8px] sm:w-[185px] sm:rounded-[3px]'
      "
      [label]="'buttons.close' | transloco" (OnClick)="closeButton()"></ln-primary-button>
  </div>
</div>
